define( 'templates/contractinfo-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            'name' : templateBuilder.sortableHeader('name', 'Contract name', 'nameCI'),
            'timezone' : templateBuilder.sortableHeader('timezone', 'Timezone', 'timezone'),
            'startDate' : templateBuilder.sortableHeader('startDate', 'Start date', 'startTime'),
            'activationEndDate' : templateBuilder.sortableHeader('activationEndDate', 'End date', 'activationEndTime'),
            'tokensInUse' : templateBuilder.sortableHeader('tokensInUse', 'Active subscriptions', 'tokensInUse'),
            'tokensUsed' : templateBuilder.sortableHeader('tokensUsed', 'Ended subscriptions', 'tokensUsed'),
            'maxTokens' : templateBuilder.sortableHeader('maxTokens', 'Max devices', 'maxTokens'),
            
            // Basic 
            'group' : templateBuilder.basicHeader('group', 'Group'),
            'clientName' : templateBuilder.basicHeader('clientName', 'Client'),
            'roaming' : templateBuilder.basicHeader('roaming', 'Roaming'),
            'tokenDuration' : templateBuilder.basicHeader('tokenDuration', 'Subscription duration'),
            'testMessages' : templateBuilder.basicHeader('testMessages', 'Test frames', 'testMessages'),
            'geolocationMode' : templateBuilder.basicHeader('geolocationMode', "Sigfox Geolocation service"),
            'pricingModel' : templateBuilder.basicHeader('pricingModel', 'Pricing model'),
            'subscriptionPlan' : templateBuilder.basicHeader('subscriptionPlan', 'Subscription plan')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'name' : {
                'nodeType':'td',
                'content': {
                    'classes' : ['contract-info-link'],
                    'data' : {
                        'start-time' : '${startTime}',
                        'end-time' : '${endTime}', 
                        'max-tokens' : '${maxTokens}', 
                        'id' :  '${id}', 
                        'has-next' : '${hasNext}',
                        'is-next' : '${isNext}'
                    },
                    'nodeType':'a',
                    'href': '${url}',
                    'content': '${name}'
                }            
            },
            'timezone' : templateBuilder.basicNode( '${timezone}' ),
            'clientName' : templateBuilder.basicNode( '${clientName}' ),
            'group' : templateBuilder.linkNode( '${groupUrl}' ,'${groupName}' ),
            'startDate' : templateBuilder.basicNode( '${startDate}' ),
            'activationEndDate' : templateBuilder.basicNode( '${activationEndDate}' ),
            'tokenDuration' : templateBuilder.basicNode( '${tokenDurationToDisplay}',null, {'align' : 'center'} ),
            'pricingModel' : templateBuilder.basicNode( '${pricingModelToDisplay}',null, {'align' : 'center'} ),
            'subscriptionPlan' : templateBuilder.basicNode( '${subscriptionPlan}',null, {'align' : 'center'} ),
            'maxTokens' : templateBuilder.basicNode( '${maxTokensToDisplay}',null, {'align' : 'center'} ),
            'geolocationMode' : templateBuilder.basicNode( '${geolocationMode}',null, {'align' : 'center'} ),
            'roaming' : templateBuilder.booleanNode( '${roaming}'),
            'testMessages' : templateBuilder.basicNode( '${testMessages}', null, {'align' : 'center'}),
            'tokensInUse' : templateBuilder.basicNode( '${tokensInUse}', null, {'align' : 'center'}),
            'tokensUsed' : templateBuilder.basicNode( '${tokensUsed}', null, {'align' : 'center'})
        } // end templates data
    }; // end return
});

